import { connect } from "react-redux";
import React, { Component } from "react";
import MainTemplate from "../mainTemplate";
// import Tab from 'canvas-core-react/lib/Tab';
// import Tabs from 'canvas-core-react/lib/Tabs';
import Tabs from "../../public/tableProvider/tabs";
import { moduleAction } from "../../utils/functions";
import UserApprovalsComponent from "./elements/users";
import ClientApprovalsComponent from "./elements/clients";
import { getRoles } from "../../../Redux/reducer/session";
import ProviderApprovalsComponent from "./elements/providers";
import NotificationApprovalsComponent from "./elements/notifications";
import AccountApproval from "./elements/AccountApproval";
import i18next from "i18next";
import {
  EXECUTE,
  MOD_USER,
  MOD_PARAM,
  MOD_CUSTOM,
  MOD_PROVID,
} from "../../../permissions";
import Bills from "./elements/bills";

export class AdminApprovals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      search: undefined,
    };
  }

  setFilterSearch = ({ filters, search }) => {
    this.setState({ filters, search });
  };

  getAdmissions = () => {
    const { roles } = this.props;
    const { filters, search } = this.state;
    var aproval,
      users,
      providers = {};
    var children = [];

    if (moduleAction(roles, MOD_USER, EXECUTE) === true) {
      users = {
        label: `${i18next.t("admissions.tabs.users")}`,
      };
      children.push(
        <div key={`userApproval`} {...users}>
          <UserApprovalsComponent setFilters={this.setFilterSearch} />
        </div>
      );
    }

    if (moduleAction(roles, MOD_CUSTOM, EXECUTE) === true) {
      aproval = {
        label: `${i18next.t("admissions.tabs.clients")}`,
      };
      children.push(
        <div key={`clientApproval`} {...aproval}>
          <ClientApprovalsComponent setFilters={this.setFilterSearch} />
        </div>
      );
    }
    if (moduleAction(roles, MOD_PROVID, EXECUTE) === true) {
      providers = {
        label: `${i18next.t("admissions.tabs.suppliers")}`,
      };
      children.push(
        <div key={`providerApproval`} {...providers}>
          <ProviderApprovalsComponent setFilters={this.setFilterSearch} />
        </div>
      );
    }
    if (moduleAction(roles, MOD_PARAM, EXECUTE) === true) {
      children.push(
        <div
          key={`notificationApprovals`}
          label={`${i18next.t("admissions.tabs.notifications")}`}
        >
          <NotificationApprovalsComponent setFilters={this.setFilterSearch} />
        </div>
      );
    }
    // if (moduleAction(roles, MOD_PARAM, EXECUTE) === true) {
    //   children.push(
    //     <div key={`notificationApprovals`} label={`Gestión de Notificaciones`}>
    //       <NotificationAdministrationComponent setFilters={this.setFilterSearch} />
    //     </div>
    //   );
    // }

    if (moduleAction(roles, MOD_PROVID, EXECUTE) === true) {
      users = {
        label: `${i18next.t("admissions.tabs.accounts")}`,
      };
      children.push(
        <div key={`userApproval`} {...users}>
          <AccountApproval />
        </div>
      );
    }

    if (moduleAction(roles, MOD_PARAM, EXECUTE) === true) {
      children.push(
        <div
          key={`billsApprovals`}
          label={`${i18next.t("admissions.tabs.bills")}`}
        >
          <Bills setFilters={this.setFilterSearch} />
        </div>
      );
    }

    return (
      <Tabs filterItems={filters} filterSearch={search}>
        {children}
      </Tabs>
    );
  };

  render() {
    return (
      <MainTemplate>
        <div id="approvals">
          <div className="header-tabs">{this.getAdmissions()}</div>
        </div>
      </MainTemplate>
    );
  }
}
export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
  };
};

export default connect(mapStateToProps, null)(AdminApprovals);
